// Direct port of evals/adapters/_normalize.py — keep the policy in
// lockstep so canonical CSVs from the browser ingest are byte-identical
// to the desktop / Python ingest. See the source's module docstring.
//
// Policy:
// - Strip C0/C1 control characters EXCEPT \n (U+000A) and \t (U+0009).
// - Preserve emoji + ZWJ sequences + skin-tone modifiers verbatim.
// - Preserve zero-width / RTL-override Unicode verbatim. (Flagging
//   adversarial invisible-char usage is a future enhancement; corrupting
//   silently is worse.)
// - No Unicode normalization (no NFC/NFD/NFKC).

const C0_KEEP = new Set<number>([0x09, 0x0a]);

function isStripped(cp: number): boolean {
  if (C0_KEEP.has(cp)) return false;
  if (cp >= 0x00 && cp < 0x20) return true;
  if (cp >= 0x80 && cp < 0xa0) return true;
  return false;
}

export function sanitizeBody(s: string): [string, number] {
  if (!s) return [s, 0];
  let stripped = 0;
  let out = "";
  for (const ch of s) {
    // Iterating with for…of yields code points (surrogate-pair-safe).
    const cp = ch.codePointAt(0)!;
    if (isStripped(cp)) {
      stripped++;
      continue;
    }
    out += ch;
  }
  return [out, stripped];
}

export const sanitizeActor = sanitizeBody;
